import { Outlet, NavLink, useNavigate, useMatch } from 'react-router'
import { LayoutDashboard, Users, Scale, ArrowRight, Settings } from 'lucide-react'

import { ui } from '@/shared/strings/ui'

const navItems = [
  { to: '/admin/competitions', label: 'المسابقات', icon: LayoutDashboard },
  { to: '/admin/students', label: 'الطلاب', icon: Users },
  { to: '/admin/judges', label: 'المحكّمون', icon: Scale },
  { to: '/admin/settings', label: 'الإعدادات', icon: Settings },
]

export function AdminLayout(): React.ReactElement {
  const navigate = useNavigate()
  const isCompetitionDetail = useMatch('/admin/competitions/:id/*')

  return (
    <div className="flex min-h-screen overflow-x-hidden">
      {/* Sidebar */}
      <aside className="hidden w-64 flex-shrink-0 border-e border-border/30 bg-card md:block">
        <div className="flex h-14 items-center px-6">
          <h1 className="text-sm font-semibold text-primary">نظام التحكيم</h1>
        </div>
        <nav className="flex flex-1 flex-col justify-between px-3 pt-2">
          <div className="flex flex-col gap-0.5">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-all duration-100 ${
                    isActive
                      ? 'bg-primary/10 text-primary'
                      : 'text-muted-foreground hover:bg-muted/60 hover:text-foreground'
                  }`
                }
              >
                <item.icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      </aside>

      {/* Main content */}
      <div className="flex min-w-0 flex-1 flex-col">
        {/* Top bar — only shows back button in competition detail */}
        {isCompetitionDetail && (
          <header className="sticky top-0 z-10 bg-background/80 backdrop-blur-xl">
            <div className="flex h-11 items-center px-4 md:px-6">
              <button
                onClick={() => navigate('/admin/competitions')}
                className="flex min-h-[44px] items-center gap-2 text-sm font-medium text-muted-foreground transition-all duration-100 hover:text-foreground active:opacity-70"
              >
                <ArrowRight className="h-4 w-4" />
                {ui.competitions.title}
              </button>
            </div>
          </header>
        )}

        {/* Page content */}
        <main className="flex-1 px-4 py-4 pb-24 md:px-6 md:pb-6">
          <Outlet />
        </main>
      </div>

      {/* Mobile bottom navigation */}
      <nav className="fixed inset-x-0 bottom-0 z-50 bg-background/80 backdrop-blur-xl pb-[env(safe-area-inset-bottom)] md:hidden">
        <div className="flex items-center justify-around">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex min-h-[52px] flex-1 flex-col items-center justify-center gap-1 text-xs font-medium transition-all duration-100 ${
                  isActive ? 'text-primary' : 'text-muted-foreground'
                }`
              }
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  )
}
